import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Navbar from "./Navbar";
import Footer from "./Footer";
import { useNavigate } from 'react-router-dom';
import Testimonial from "./IMGS/Testimonial.png";
import Testimonial_2 from "./IMGS/Testimonial_2.png"

//const API_BASE_URL = 'http://localhost/royaleheritagefiesta/api';
const API_BASE_URL = 'https://royaleheritagefiesta.com/royaleheritagefiesta/api';

const ContactUs = () => {
  const navigate = useNavigate();
  const [showBackToTop, setShowBackToTop] = useState(false);
  const [showFloatingButtons, setFloatingButtons] = useState(false);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    service: '',
    contactTime: '',
    message: ''
  });
  const [formStatus, setFormStatus] = useState({ submitted: false, error: '', loading: false, message: '' });
  const [activeFaq, setActiveFaq] = useState(null);
  
  // CMS Content State
  const [cmsContent, setCmsContent] = useState(null);

  // WhatsApp number (will be updated from CMS)
  const [whatsappNumber, setWhatsappNumber] = useState('9966252374');

  // Default data (existing content)
  const defaultTeamMembers = [
    {
      name: 'Rajesh Singh',
      position: 'Royal Event Director',
      experience: '12+ Years Experience',
      expertise: ['Royal Heritage Festia', 'Grand Celebrations', 'Cultural Events'],
      image: Testimonial
    },
    {
      name: 'Priya Reddy',
      position: 'Royal Dining Curator',
      experience: '10+ Years Experience',
      expertise: ['Royal Dinners', 'Culinary Excellence', 'VIP Hospitality'],
      image: Testimonial_2
    },
    {
      name: 'Arjun Nair',
      position: 'Music & Concerts Director',
      experience: '15+ Years Experience',
      expertise: ['Live Concerts', 'Music Festivals', 'Artist Management'],
      image: Testimonial
    },
    {
      name: 'Meera Kapoor',
      position: 'Guest Relations Head',
      experience: '8+ Years Experience',
      expertise: ['Guest Experience', 'Royal Protocol', 'VIP Services'],
      image: Testimonial_2
    }
  ];

  const defaultFaqs = [
    {
      question: 'What is included in the Royal Heritage Festia experience?',
      answer: 'Royal Heritage Festia includes curated heritage walks, royal processions, cultural performances, traditional cuisine, and immersive experiences that celebrate royal traditions and grandeur.'
    },
    {
      question: 'How far in advance should I book a Royal Dinner?',
      answer: 'We recommend booking Royal Dinners 3-6 months in advance to ensure availability of Michelin-star chefs, premium venues, and the perfect royal ambiance for your celebration.'
    },
    {
      question: 'Do you handle international artists for Music & Concerts?',
      answer: 'Yes! We have partnerships with world-class international artists and can arrange everything from booking to technical production for spectacular musical experiences.'
    },
    {
      question: 'Can I customize the Royal Dinners menu?',
      answer: 'Absolutely! Our culinary team works closely with you to create a bespoke menu that reflects your preferences, dietary requirements, and the royal theme of your event.'
    }
  ];

  const defaultContactCards = [
    { icon: 'bi-telephone-fill', title: 'Call Us', subtitle: 'Available 24/7', contact: '+91 99662 52374', link_type: 'tel', action: 'Call Now' },
    { icon: 'bi-envelope-fill', title: 'Email Us', subtitle: '24hr Response', contact: 'royaleheritagefietsa@gmail.com', link_type: 'email', action: 'Send Email' },
    { icon: 'bi-whatsapp', title: 'WhatsApp', subtitle: 'Instant Chat', contact: '+91 99662 52374', link_type: 'whatsapp', action: 'Start Chat' }
  ];

  const defaultStats = [
    { icon: 'bi-globe2', number: '500+', label: 'Royal Events' },
    { icon: 'bi-clock-history', number: '24/7', label: 'Royal Support' },
    { icon: 'bi-hourglass-split', number: '<2hr', label: 'Response Time' },
    { icon: 'bi-star-fill', number: '98%', label: 'Satisfaction' }
  ];

  const heroStats = [
    { number: '500+', label: 'Royal Events' },
    { number: '24/7', label: 'Royal Support' },
    { number: '20+', label: 'Countries' }
  ];

  // Fetch contact content from API
  const fetchContactContent = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/get-contact-content.php`);
      console.log('Contact API Response:', response.data);
      
      if (response.data.success && response.data.data) {
        setCmsContent(response.data.data);
        
        // Update WhatsApp number from CMS
        if (response.data.data.cta?.phone) {
          const phone = response.data.data.cta.phone.replace('+91', '');
          setWhatsappNumber(phone);
        }
      }
    } catch (error) {
      console.error('Error fetching contact content:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContactContent();
  }, []);

  useEffect(() => {
    if (window.AOS) {
      window.AOS.init({
        duration: 800,
        once: true,
        offset: 50
      });
    }

    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 300);
      setFloatingButtons(window.scrollY > 500);
    };
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleBackToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleHomeClick = () => {
    navigate('/');
  };

  const handleWhatsAppClick = () => {
    window.open(`https://wa.me/${whatsappNumber}?text=Hi%20Royal%20Heritage%20Festia%20team,%20I%27m%20interested%20in%20your%20services.`, '_blank');
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    
    const { name, email, message } = formData;
    
    if (name && email && message) {
      setFormStatus({ 
        submitted: false, 
        error: '',
        loading: true,
        message: 'Sending your message...'
      });

      try {
        const whatsappMessage = `*ROYAL HERITAGE FESTIA - New Contact Enquiry*%0A%0A` +
          `*Name:* ${formData.name}%0A` +
          `*Company:* ${formData.company || 'Not provided'}%0A` +
          `*Email:* ${formData.email}%0A` +
          `*Phone:* ${formData.phone || 'Not provided'}%0A` +
          `*Service:* ${formData.service || 'Not specified'}%0A` +
          `*Preferred Contact Time:* ${formData.contactTime || 'Any time'}%0A%0A` +
          `*Message:*%0A${formData.message}%0A%0A` +
          `---%0A*Enquiry submitted from Royal Heritage Festia website*`;
        
        const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;
        
        alert("✓ Your enquiry has been prepared!\n\nYou will now be redirected to WhatsApp to send your message.");
        
        window.open(whatsappUrl, '_blank');
        
        setFormStatus({ 
          submitted: true, 
          error: '',
          loading: false,
          message: 'Thank you! We\'ll respond within 24 hours.'
        });
        
        setFormData({
          name: '',
          company: '',
          email: '',
          phone: '',
          service: '',
          contactTime: '',
          message: ''
        });
        
        setTimeout(() => setFormStatus({ submitted: false, error: '', loading: false, message: '' }), 5000);
        
      } catch (error) {
        setFormStatus({ 
          submitted: false, 
          error: 'Failed to send message. Please try again.',
          loading: false,
          message: ''
        });
        
        setTimeout(() => setFormStatus({ submitted: false, error: '', loading: false, message: '' }), 5000);
      }
    } else {
      setFormStatus({ 
        submitted: false, 
        error: 'Please fill in all required fields.',
        loading: false,
        message: ''
      });
    }
  };

  const toggleFaq = (index) => {
    setActiveFaq(activeFaq === index ? null : index);
  };

  // Get data from CMS or use defaults
  const heroData = cmsContent?.hero || { title: "Let's Create Something Royal", subtitle: "Your vision deserves royal execution. Reach out to our team of experts.", badge: "✦ CONNECT WITH US" };
  const contactCards = cmsContent?.contact_cards && cmsContent.contact_cards.length > 0 ? cmsContent.contact_cards : defaultContactCards;
  const statsData = cmsContent?.stats && cmsContent.stats.length > 0 ? cmsContent.stats : defaultStats;
  const officeData = cmsContent?.office || { title: "Hyderabad Headquarters", address: "VIP Hills, Silicon valley, Madhapur, Hyderabad - 500081, Telangana", hours: "Monday - Friday: 9:00 AM - 7:00 PM, Saturday: 10:00 AM - 4:00 PM", availability: "Meetings by appointment, Virtual consultations, 24/7 emergency", map_embed: "https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d7612.584996745508!2d78.38633559192071!3d17.445708893577407!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1774850334297!5m2!1sen!2sin" };
  const teamData = cmsContent?.team?.members && cmsContent.team.members.length > 0 ? cmsContent.team.members : defaultTeamMembers;
  const faqData = cmsContent?.faq?.items && cmsContent.faq.items.length > 0 ? cmsContent.faq.items : defaultFaqs;
  const ctaData = cmsContent?.cta || { title: "Ready to Create Your Royal Experience?", subtitle: "Call us now or visit our Hyderabad office for a personal consultation", button1_text: "Call +91 99662 52374", button2_text: "WhatsApp Us", phone: "+919966252374" };
  const heroStatsData = cmsContent?.hero?.stats && cmsContent.hero.stats.length > 0 ? cmsContent.hero.stats : heroStats;

  if (loading) {
    return (
      <>
        <Navbar />
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          minHeight: '60vh',
          backgroundColor: '#f5f5f5'
        }}>
          <div className="spinner-border text-warning" style={{ width: '3rem', height: '3rem' }} role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />

      <style>{`
        /* ===== ROYAL HERITAGE THEME - Contact Page Only ===== */
        /* These styles only apply to Contact page elements */
        
        .contact-main-container {
          background: #f5f5f5;
          margin: 0 auto;
          width: 100%;
          max-width: 1400px;
          border-left: 23px solid #000;
          border-right: 23px solid #000;
          border-radius: 0;
        }

        /* Section Headers */
        .contact-main-container .section-header {
          text-align: center;
          margin-bottom: 2.5rem;
        }
        
        .contact-main-container .section-header h2 {
          font-family: 'Cinzel', serif;
          font-size: clamp(1.5rem, 5vw, 2rem);
          font-weight: 700;
          color: #000;
          margin-bottom: 0.75rem;
        }
        
        .contact-main-container .section-header p {
          color: #666;
          font-size: clamp(0.85rem, 3vw, 0.95rem);
          max-width: 600px;
          margin: 0 auto;
        }
        
        .contact-main-container .section-tag {
          color: #b8860b;
          font-size: clamp(0.7rem, 2.5vw, 0.8rem);
          letter-spacing: 2px;
          text-transform: uppercase;
          display: inline-block;
          margin-bottom: 0.5rem;
        }

        /* Hero Section */
        .contact-hero {
          padding: clamp(2rem, 8vw, 4rem) clamp(1rem, 4vw, 2rem);
          background: linear-gradient(rgba(0,0,0,0.65), rgba(0,0,0,0.65)), url('https://images.unsplash.com/photo-1536392706976-e486e2ba97af?q=80&w=2000&auto=format');
          background-size: cover;
          background-position: center;
          text-align: center;
          margin-bottom: 2rem;
        }
        
        .contact-hero h1 {
          font-family: 'Cinzel', serif;
          font-size: clamp(1.8rem, 7vw, 3rem);
          font-weight: 700;
          color: #fff;
          margin-bottom: 1rem;
        }
        
        .contact-hero .highlight {
          color: #b8860b;
        }
        
        .gradient-text {
          background: linear-gradient(135deg, #b8860b, #d4af37);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
        
        .contact-hero p {
          font-size: clamp(0.9rem, 3.5vw, 1.1rem);
          color: rgba(255,255,255,0.9);
          max-width: 700px;
          margin: 0 auto;
        }
        
        .hero-badge {
          display: inline-block;
          background: rgba(184,134,11,0.2);
          backdrop-filter: blur(5px);
          color: white;
          padding: 0.5rem 1.5rem;
          border-radius: 40px;
          margin-bottom: 1.5rem;
          border: 1px solid rgba(255,255,255,0.3);
          font-size: 12px;
          letter-spacing: 2px;
        }
        
        .hero-stats-mini {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 2rem;
          margin-top: 2rem;
          background: rgba(0,0,0,0.5);
          backdrop-filter: blur(10px);
          padding: 1rem 2rem;
          border-radius: 60px;
          width: fit-content;
          margin-left: auto;
          margin-right: auto;
          border: 1px solid rgba(184,134,11,0.3);
          flex-wrap: wrap;
        }
        
        .hero-stat-item {
          text-align: center;
        }
        
        .hero-stat-number {
          display: block;
          font-size: clamp(1.2rem, 4vw, 1.5rem);
          font-weight: 700;
          color: #b8860b;
        }
        
        .hero-stat-label {
          font-size: clamp(0.7rem, 2.5vw, 0.8rem);
          color: rgba(255,255,255,0.8);
        }
        
        .hero-stat-divider {
          width: 1px;
          height: 30px;
          background: rgba(255,255,255,0.3);
        }

        /* Contact Cards - FIXED FOR MOBILE */
        .contact-info-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 1.5rem;
          margin: -2rem 0 2rem 0;
          padding: 0 1rem;
          width: 100%;
          box-sizing: border-box;
        }
        
        .contact-card {
          background: #fff;
          border-radius: 12px;
          padding: clamp(1rem, 4vw, 1.5rem);
          text-align: center;
          box-shadow: 0 3px 15px rgba(0,0,0,0.08);
          transition: 0.3s;
          border: 1px solid #eee;
          width: 100%;
          box-sizing: border-box;
          overflow: hidden;
          word-wrap: break-word;
        }
        
        .contact-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 30px rgba(184,134,11,0.15);
          border-color: #b8860b;
        }
        
        .contact-icon {
          width: clamp(50px, 10vw, 60px);
          height: clamp(50px, 10vw, 60px);
          background: rgba(184,134,11,0.1);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 1rem;
        }
        
        .contact-icon i {
          font-size: clamp(1.3rem, 4vw, 1.6rem);
          color: #b8860b;
        }
        
        .contact-card h3 {
          font-family: 'Cinzel', serif;
          font-size: clamp(1rem, 4vw, 1.2rem);
          font-weight: 700;
          margin-bottom: 0.3rem;
          color: #000;
        }
        
        .contact-subtitle {
          color: #666;
          font-size: clamp(0.7rem, 2.5vw, 0.75rem);
          margin-bottom: 1rem;
        }
        
        .contact-phone, .contact-whatsapp {
          font-size: clamp(0.9rem, 3vw, 1rem);
          font-weight: 700;
          color: #b8860b;
          margin: 0;
          word-break: break-word;
        }
        
        .contact-email {
          font-size: clamp(0.8rem, 2.8vw, 0.85rem);
          color: #666;
          word-break: break-word;
        }
        
        .contact-link {
          display: inline-block;
          margin-top: 1rem;
          padding: 0.5rem 1rem;
          border: 1px solid #b8860b;
          border-radius: 30px;
          color: #b8860b;
          text-decoration: none;
          font-size: clamp(0.75rem, 2.5vw, 0.8rem);
          transition: 0.3s;
        }
        
        .contact-link:hover {
          background: #b8860b;
          color: #fff;
        }
        
        .online-badge {
          display: inline-block;
          background: rgba(16,185,129,0.1);
          color: #10b981;
          padding: 0.2rem 0.6rem;
          border-radius: 20px;
          font-size: 0.65rem;
          margin-top: 0.5rem;
        }

        /* Stats Section */
        .corporate-stats {
          padding: clamp(1.5rem, 5vw, 2rem) 0;
          background: #f5f5f5;
        }
        
        .stats-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 1.5rem;
        }
        
        .stat-card {
          background: #fff;
          padding: clamp(1rem, 4vw, 1.5rem);
          border-radius: 12px;
          display: flex;
          align-items: center;
          gap: 1rem;
          box-shadow: 0 2px 10px rgba(0,0,0,0.05);
          transition: 0.3s;
          border: 1px solid #eee;
        }
        
        .stat-card:hover {
          transform: translateY(-3px);
          box-shadow: 0 8px 20px rgba(184,134,11,0.1);
          border-color: #b8860b;
        }
        
        .stat-icon {
          width: clamp(45px, 8vw, 50px);
          height: clamp(45px, 8vw, 50px);
          background: rgba(184,134,11,0.1);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }
        
        .stat-icon i {
          font-size: clamp(1.2rem, 3.5vw, 1.4rem);
          color: #b8860b;
        }
        
        .stat-content h3 {
          font-family: 'Cinzel', serif;
          font-size: clamp(1.1rem, 4vw, 1.3rem);
          font-weight: 700;
          color: #b8860b;
          margin: 0;
        }
        
        .stat-content p {
          color: #666;
          font-size: clamp(0.7rem, 2.5vw, 0.75rem);
          margin: 0;
        }

        /* Form Section */
        .contact-form-wrapper {
          background: #fff;
          padding: clamp(1.2rem, 5vw, 2rem);
          border-radius: 16px;
          box-shadow: 0 3px 15px rgba(0,0,0,0.05);
          border: 1px solid #eee;
          height: 100%;
        }
        
        .form-title {
          font-family: 'Cinzel', serif;
          font-size: clamp(1.3rem, 5vw, 1.5rem);
          font-weight: 700;
          color: #000;
          margin-bottom: 0.5rem;
        }
        
        .form-subtitle {
          color: #666;
          font-size: clamp(0.8rem, 2.8vw, 0.85rem);
          margin-bottom: 1.5rem;
        }
        
        .form-control, .form-select {
          width: 100%;
          padding: 0.7rem 1rem;
          border: 1px solid #ddd;
          border-radius: 8px;
          font-size: clamp(0.8rem, 2.8vw, 0.85rem);
          transition: 0.3s;
          box-sizing: border-box;
        }
        
        .form-control:focus, .form-select:focus {
          border-color: #b8860b;
          outline: none;
          box-shadow: 0 0 0 2px rgba(184,134,11,0.1);
        }
        
        .form-label {
          font-weight: 600;
          font-size: clamp(0.75rem, 2.5vw, 0.8rem);
          margin-bottom: 0.3rem;
          display: block;
          color: #333;
        }
        
        .btn-submit {
          background: #b8860b;
          color: #fff;
          border: none;
          padding: 0.8rem 2rem;
          border-radius: 50px;
          font-weight: 600;
          font-size: clamp(0.85rem, 3vw, 0.9rem);
          cursor: pointer;
          transition: 0.3s;
          width: 100%;
        }
        
        .btn-submit:hover {
          background: #9b6e09;
          transform: translateY(-2px);
        }

        /* Office Card */
        .office-card {
          background: #fff;
          padding: clamp(1.2rem, 5vw, 2rem);
          border-radius: 16px;
          box-shadow: 0 3px 15px rgba(0,0,0,0.05);
          border: 1px solid #eee;
          height: 100%;
        }
        
        .office-card h3 {
          font-family: 'Cinzel', serif;
          font-size: clamp(1.1rem, 4vw, 1.3rem);
          font-weight: 700;
          margin-bottom: 1.5rem;
          color: #000;
          display: flex;
          align-items: center;
          gap: 0.5rem;
          flex-wrap: wrap;
        }
        
        .office-detail {
          display: flex;
          gap: 1rem;
          margin-bottom: 1rem;
          padding: clamp(0.8rem, 3vw, 1rem);
          background: #f9f5e8;
          border-radius: 12px;
        }
        
        .office-detail i {
          font-size: clamp(1rem, 3vw, 1.2rem);
          color: #b8860b;
          flex-shrink: 0;
        }
        
        .office-detail h4 {
          font-size: clamp(0.85rem, 3vw, 0.9rem);
          font-weight: 700;
          margin-bottom: 0.3rem;
          color: #000;
        }
        
        .office-detail p {
          color: #666;
          font-size: clamp(0.75rem, 2.5vw, 0.8rem);
          margin: 0;
          word-break: break-word;
        }
        
        .timing-badge {
          display: inline-block;
          background: rgba(184,134,11,0.1);
          color: #b8860b;
          padding: 0.2rem 0.6rem;
          border-radius: 20px;
          font-size: clamp(0.65rem, 2.5vw, 0.7rem);
          margin-right: 0.5rem;
          margin-bottom: 0.5rem;
        }
        
        .availability-status {
          background: linear-gradient(135deg, rgba(184,134,11,0.05), rgba(184,134,11,0.02));
          border-radius: 12px;
          padding: 1rem;
          margin-top: 1rem;
          border: 1px dashed #b8860b;
        }
        
        .status-dot {
          width: 8px;
          height: 8px;
          background: #10b981;
          border-radius: 50%;
          display: inline-block;
          animation: pulse 2s infinite;
        }
        
        @keyframes pulse {
          0% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.5; transform: scale(1.2); }
          100% { opacity: 1; transform: scale(1); }
        }

        /* Map Section */
        .map-section {
          padding: clamp(1.5rem, 5vw, 2rem) 0;
          background: #f5f5f5;
        }
        
        .map-card {
          background: #fff;
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 3px 15px rgba(0,0,0,0.08);
          border: 1px solid #eee;
          max-width: 1000px;
          margin: 0 auto;
        }
        
        .map-container {
          width: 100%;
          height: clamp(250px, 40vw, 350px);
        }
        
        .map-container iframe {
          width: 100%;
          height: 100%;
          border: 0;
        }

        /* Team Section */
        .team-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 1.5rem;
        }
        
        .team-card {
          background: #fff;
          padding: clamp(1rem, 4vw, 1.5rem);
          border-radius: 16px;
          text-align: center;
          box-shadow: 0 3px 15px rgba(0,0,0,0.05);
          transition: 0.3s;
          border: 1px solid #eee;
        }
        
        .team-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 30px rgba(184,134,11,0.15);
          border-color: #b8860b;
        }
        
        .team-img {
          width: clamp(80px, 15vw, 100px);
          height: clamp(80px, 15vw, 100px);
          border-radius: 50%;
          margin: 0 auto 1rem;
          overflow: hidden;
          border: 2px solid #b8860b;
        }
        
        .team-img img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        
        .team-card h4 {
          font-family: 'Cinzel', serif;
          font-size: clamp(0.9rem, 3vw, 1rem);
          font-weight: 700;
          margin-bottom: 0.2rem;
          color: #000;
        }
        
        .team-position {
          color: #b8860b;
          font-size: clamp(0.65rem, 2.5vw, 0.7rem);
          font-weight: 600;
          margin-bottom: 0.5rem;
        }
        
        .team-experience {
          background: rgba(184,134,11,0.1);
          color: #b8860b;
          padding: 0.2rem 0.6rem;
          border-radius: 20px;
          font-size: clamp(0.65rem, 2.5vw, 0.7rem);
          display: inline-block;
          margin-bottom: 0.8rem;
        }
        
        .team-expertise {
          list-style: none;
          padding: 0;
          text-align: left;
        }
        
        .team-expertise li {
          font-size: clamp(0.65rem, 2.5vw, 0.7rem);
          color: #666;
          margin-bottom: 0.3rem;
          display: flex;
          align-items: center;
          gap: 0.4rem;
        }
        
        .team-expertise li i {
          color: #b8860b;
          font-size: 0.7rem;
          flex-shrink: 0;
        }

        /* FAQ Section */
        .faq-section {
          background: #000;
          padding: clamp(2rem, 6vw, 3rem) 0;
        }
        
        .faq-section .section-header h2 {
          color: #fff;
        }
        
        .faq-section .section-header p {
          color: #aaa;
        }
        
        .faq-item {
          background: #fff;
          border: 1px solid #eee;
          border-radius: 12px;
          margin-bottom: 1rem;
          overflow: hidden;
        }
        
        .faq-question {
          padding: clamp(0.8rem, 3vw, 1rem);
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          background: #fff;
        }
        
        .faq-question h5 {
          font-size: clamp(0.85rem, 2.8vw, 0.9rem);
          font-weight: 600;
          color: #000;
          margin: 0;
          flex: 1;
          padding-right: 1rem;
        }
        
        .faq-icon {
          width: 28px;
          height: 28px;
          background: #b8860b;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          transition: 0.3s;
          flex-shrink: 0;
        }
        
        .faq-icon.active {
          transform: rotate(180deg);
        }
        
        .faq-answer {
          max-height: 0;
          opacity: 0;
          overflow: hidden;
          transition: 0.3s;
          padding: 0 1rem;
        }
        
        .faq-answer.show {
          max-height: 200px;
          opacity: 1;
          padding: 0 1rem 1rem 1rem;
        }
        
        .faq-answer p {
          color: #666;
          font-size: clamp(0.8rem, 2.8vw, 0.85rem);
          margin: 0;
        }

        /* CTA Section */
        .cta-section {
          padding: clamp(2rem, 6vw, 3rem) 0;
          background: #000;
          text-align: center;
        }
        
        .cta-section h2 {
          font-family: 'Cinzel', serif;
          font-size: clamp(1.3rem, 5vw, 1.8rem);
          font-weight: 700;
          color: #fff;
          margin-bottom: 1rem;
          padding: 0 1rem;
        }
        
        .cta-section p {
          color: #aaa;
          font-size: clamp(0.85rem, 3vw, 0.9rem);
          margin-bottom: 2rem;
          padding: 0 1rem;
        }
        
        .cta-buttons {
          display: flex;
          gap: 1rem;
          justify-content: center;
          flex-wrap: wrap;
          padding: 0 1rem;
        }
        
        .btn-cta {
          padding: clamp(0.7rem, 3vw, 0.8rem) clamp(1.2rem, 4vw, 2rem);
          border-radius: 50px;
          font-weight: 600;
          font-size: clamp(0.85rem, 3vw, 0.9rem);
          text-decoration: none;
          transition: 0.3s;
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
        }
        
        .btn-cta-primary {
          background: #b8860b;
          color: #fff;
        }
        
        .btn-cta-primary:hover {
          background: #9b6e09;
          transform: translateY(-2px);
        }
        
        .btn-cta-secondary {
          border: 2px solid #b8860b;
          color: #fff;
          background: transparent;
        }
        
        .btn-cta-secondary:hover {
          background: #b8860b;
          transform: translateY(-2px);
        }

        /* Container and Grid */
        .contact-main-container .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 1rem;
          box-sizing: border-box;
        }
        
        .contact-main-container .row {
          display: flex;
          flex-wrap: wrap;
          margin: 0 -0.75rem;
        }
        
        .contact-main-container [class*="col-"] {
          padding: 0 0.75rem;
          box-sizing: border-box;
        }
        
        .contact-main-container .col-12 { flex: 0 0 100%; max-width: 100%; }
        .contact-main-container .col-md-6 { flex: 0 0 50%; max-width: 50%; }
        .contact-main-container .col-lg-5 { flex: 0 0 41.666%; max-width: 41.666%; }
        .contact-main-container .col-lg-7 { flex: 0 0 58.333%; max-width: 58.333%; }
        .contact-main-container .col-lg-8 { flex: 0 0 66.666%; max-width: 66.666%; }
        
        .contact-main-container .py-5 { padding-top: clamp(2rem, 6vw, 2.5rem); padding-bottom: clamp(2rem, 6vw, 2.5rem); }
        .contact-main-container .mt-3 { margin-top: 1rem; }
        .contact-main-container .mb-4 { margin-bottom: 1.5rem; }
        .contact-main-container .text-center { text-align: center; }
        .contact-main-container .bg-light { background: #f5f5f5; }
        
        /* Alert Styles */
        .alert {
          padding: 0.8rem;
          border-radius: 8px;
          margin-bottom: 1rem;
          font-size: 0.85rem;
        }
        
        .alert-success {
          background: #d4edda;
          color: #155724;
        }
        
        .alert-danger {
          background: #f8d7da;
          color: #721c24;
        }
        
        .alert-info {
          background: #d1ecf1;
          color: #0c5460;
        }

        /* Floating Buttons */
        .floating-buttons {
          position: fixed;
          bottom: 20px;
          right: 20px;
          display: flex;
          flex-direction: column;
          gap: 10px;
          z-index: 1000;
          opacity: 0;
          visibility: hidden;
          transition: 0.3s;
        }
        
        .floating-buttons.show {
          opacity: 1;
          visibility: visible;
        }
        
        .floating-btn {
          width: 45px;
          height: 45px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: 0.3s;
          border: none;
          box-shadow: 0 2px 10px rgba(0,0,0,0.2);
        }
        
        .floating-btn.whatsapp { background: #25d366; color: #fff; }
        .floating-btn.home { background: #b8860b; color: #fff; }
        .floating-btn.top { background: #b8860b; color: #fff; }
        .floating-btn:hover { transform: scale(1.1); }
        
        .back-to-top {
          position: fixed;
          bottom: 20px;
          right: 20px;
          width: 45px;
          height: 45px;
          background: #b8860b;
          color: #fff;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          opacity: 0;
          visibility: hidden;
          transition: 0.2s;
          z-index: 99;
          box-shadow: 0 2px 10px rgba(0,0,0,0.2);
        }
        
        .back-to-top.show {
          opacity: 1;
          visibility: visible;
        }

        /* Responsive - MOBILE FIXES */
        @media (max-width: 992px) {
          .contact-main-container .col-lg-5, 
          .contact-main-container .col-lg-7 { 
            flex: 0 0 100%; 
            max-width: 100%; 
            margin-bottom: 1rem; 
          }
        }

        @media (max-width: 768px) {
          .contact-main-container { 
            width: 100%; 
            border-left: 16px solid #000 !important; 
            border-right: 16px solid #000 !important; 
          }
          
          .hero-stats-mini { 
            flex-direction: column; 
            gap: 0.8rem; 
            padding: 1rem;
            width: 90%;
          }
          
          .hero-stat-divider { 
            display: none; 
          }
          
          .cta-buttons { 
            flex-direction: column; 
            align-items: stretch;
          }
          
          .btn-cta { 
            width: 100%; 
            text-align: center; 
            justify-content: center;
          }
          
          /* FIXED: Contact cards in mobile */
          .contact-info-grid {
            grid-template-columns: 1fr;
            gap: 1rem;
            padding: 0 0.5rem;
            margin: -1.5rem 0 2rem 0;
          }
          
          .contact-card {
            padding: 1rem;
            margin: 0;
          }
          
          .stats-grid {
            grid-template-columns: 1fr;
          }
          
          .team-grid {
            grid-template-columns: 1fr;
          }
          
          .floating-buttons {
            bottom: 15px;
            right: 15px;
            gap: 8px;
          }
          
          .floating-btn {
            width: 40px;
            height: 40px;
          }
          
          .back-to-top {
            width: 40px;
            height: 40px;
            bottom: 15px;
            right: 15px;
          }
          
          /* Fix for form in mobile */
          .contact-form-wrapper,
          .office-card {
            padding: 1rem;
          }
          
          .office-detail {
            flex-direction: column;
            text-align: center;
          }
          
          .office-detail i {
            margin: 0 auto;
          }
          
          .timing-badge {
            display: inline-block;
            margin: 0.2rem;
          }
        }
      `}</style>

      <div className="contact-main-container">
        {/* Hero Section */}
        <div className="contact-hero">
          <div className="container">
            <div className="hero-badge">{heroData.badge}</div>
            <h1>
              {heroData.title.split(' ').slice(0, -1).join(' ')} <span className="highlight">{heroData.title.split(' ').pop()}</span>
            </h1>
            <p>{heroData.subtitle}</p>
            <div className="hero-stats-mini">
              {heroStatsData.map((stat, idx) => (
                <React.Fragment key={idx}>
                  <div className="hero-stat-item">
                    <span className="hero-stat-number">{stat.number}</span>
                    <span className="hero-stat-label">{stat.label}</span>
                  </div>
                  {idx < heroStatsData.length - 1 && <div className="hero-stat-divider"></div>}
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>

        {/* Contact Info Cards */}
        <div className="container">
          <div className="contact-info-grid">
            {contactCards.map((card, idx) => (
              <div className="contact-card" key={idx} data-aos="fade-up" data-aos-delay={100 * (idx + 1)}>
                <div className="contact-icon"><i className={`bi ${card.icon}`}></i></div>
                <h3>{card.title}</h3>
                <p className="contact-subtitle">{card.subtitle}</p>
                <p className={card.link_type === 'email' ? 'contact-email' : 'contact-phone'}>{card.contact}</p>
                {card.link_type === 'whatsapp' && <span className="online-badge"><i className="bi bi-check-circle-fill me-1"></i> Online Now</span>}
                <a href={`${card.link_type === 'tel' ? 'tel:' : card.link_type === 'email' ? 'mailto:' : 'https://wa.me/'}${card.contact.replace(/\D/g, '')}`} className="contact-link" target="_blank" rel="noopener noreferrer">
                  {card.action} <i className="bi bi-arrow-right ms-1"></i>
                </a>
              </div>
            ))}
          </div>
        </div>

        {/* Stats Section */}
        <div className="corporate-stats">
          <div className="container">
            <div className="stats-grid">
              {statsData.map((stat, idx) => (
                <div className="stat-card" key={idx} data-aos="fade-up" data-aos-delay={100 * (idx + 1)}>
                  <div className="stat-icon"><i className={`bi ${stat.icon}`}></i></div>
                  <div className="stat-content"><h3>{stat.number}</h3><p>{stat.label}</p></div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Main Contact Section */}
        <div className="py-5">
          <div className="container">
            <div className="row">
              <div className="col-lg-7" data-aos="fade-right">
                <div className="contact-form-wrapper">
                  <h2 className="form-title">Send us a message</h2>
                  <p className="form-subtitle">Fill in the details and we'll respond within 24 hours</p>
                  
                  {formStatus.loading && <div className="alert alert-info"><i className="bi bi-hourglass-split me-2"></i>{formStatus.message}</div>}
                  {formStatus.submitted && <div className="alert alert-success"><i className="bi bi-check-circle-fill me-2"></i>{formStatus.message}</div>}
                  {formStatus.error && <div className="alert alert-danger"><i className="bi bi-exclamation-triangle-fill me-2"></i>{formStatus.error}</div>}
                  
                  <form onSubmit={handleFormSubmit}>
                    <div className="row g-3">
                      <div className="col-md-6 col-12">
                        <label className="form-label">Full name *</label>
                        <input type="text" className="form-control" name="name" value={formData.name} onChange={handleInputChange} required />
                      </div>
                      <div className="col-md-6 col-12">
                        <label className="form-label">Company</label>
                        <input type="text" className="form-control" name="company" value={formData.company} onChange={handleInputChange} />
                      </div>
                      <div className="col-md-6 col-12">
                        <label className="form-label">Email *</label>
                        <input type="email" className="form-control" name="email" value={formData.email} onChange={handleInputChange} required />
                      </div>
                      <div className="col-md-6 col-12">
                        <label className="form-label">Phone</label>
                        <input type="tel" className="form-control" name="phone" value={formData.phone} onChange={handleInputChange} placeholder="+91 99662 52374" />
                      </div>
                      <div className="col-md-6 col-12">
                        <label className="form-label">Service interested in</label>
                        <select className="form-select" name="service" value={formData.service} onChange={handleInputChange}>
                          <option value="">Select a service</option>
                          <option>Royal Heritage Festia</option>
                          <option>Royal Dinners</option>
                          <option>Music & Concerts</option>
                        </select>
                      </div>
                      <div className="col-md-6 col-12">
                        <label className="form-label">Preferred contact time</label>
                        <select className="form-select" name="contactTime" value={formData.contactTime} onChange={handleInputChange}>
                          <option>Morning (9AM - 12PM)</option>
                          <option>Afternoon (12PM - 3PM)</option>
                          <option>Evening (3PM - 6PM)</option>
                          <option>Any time</option>
                        </select>
                      </div>
                      <div className="col-12">
                        <label className="form-label">Message *</label>
                        <textarea className="form-control" name="message" rows="4" value={formData.message} onChange={handleInputChange} required></textarea>
                      </div>
                      <div className="col-12">
                        <button type="submit" className="btn-submit"><i className="bi bi-whatsapp me-2"></i>Send via WhatsApp</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              
              <div className="col-lg-5" data-aos="fade-left">
                <div className="office-card">
                  <h3><i className="bi bi-building"></i> {officeData.title}</h3>
                  <div className="office-detail">
                    <i className="bi bi-geo-alt-fill"></i>
                    <div><h4>Visit Our Venue</h4><p>{officeData.address}</p></div>
                  </div>
                  <div className="office-detail">
                    <i className="bi bi-clock-fill"></i>
                    <div><h4>Office Hours</h4><p>{officeData.hours}</p></div>
                  </div>
                  <div className="office-detail">
                    <i className="bi bi-calendar-check-fill"></i>
                    <div><h4>Availability</h4><div>{officeData.availability.split(',').map((item, i) => <span key={i} className="timing-badge">{item.trim()}</span>)}</div></div>
                  </div>
                  <div className="availability-status">
                    <div><span className="status-dot me-2"></span><strong>Royal Team Online</strong><p className="mt-1">Our team is available to respond to your queries</p></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Map Section - Card Style */}
        <div className="map-section">
          <div className="container">
            <div className="section-header">
              <span className="section-tag">✦ FIND US</span>
              <h2>Visit Our {officeData.title}</h2>
              <p>Located in the heart of Durgam Cheruvu</p>
            </div>
            <div className="map-card">
              <div className="map-container">
                <iframe 
                  src={officeData.map_embed} 
                  width="100%" 
                  height="100%" 
                  style={{ border: 0 }} 
                  allowFullScreen 
                  loading="lazy" 
                  title="Location Map">
                </iframe>
              </div>
            </div>
          </div>
        </div>

        {/* Team Section */}
        <div className="py-5">
          <div className="container">
            <div className="section-header">
              <span className="section-tag">✦ {cmsContent?.team?.title || "YOUR ROYAL TEAM"}</span>
              <h2>{cmsContent?.team?.title || "Meet Our Royal Experts"}</h2>
              <p>{cmsContent?.team?.subtitle || "Experienced professionals dedicated to making your celebrations extraordinary"}</p>
            </div>
            <div className="team-grid">
              {teamData.map((member, index) => (
                <div className="team-card" key={index} data-aos="fade-up" data-aos-delay={100 * (index + 1)}>
                  <div className="team-img"><img src={member.image || (index % 2 === 0 ? Testimonial : Testimonial_2)} alt={member.name} /></div>
                  <h4>{member.name}</h4>
                  <div className="team-position">{member.position}</div>
                  <span className="team-experience">{member.experience}</span>
                  <ul className="team-expertise">
                    {member.expertise.map((item, idx) => (<li key={idx}><i className="bi bi-check-circle-fill"></i> {item}</li>))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* FAQ Section */}
        <div className="faq-section">
          <div className="container">
            <div className="section-header">
              <span className="section-tag">✦ FAQ</span>
              <h2>{cmsContent?.faq?.title || "Frequently Asked Questions"}</h2>
              <p>{cmsContent?.faq?.subtitle || "Quick answers about our royal services"}</p>
            </div>
            <div className="row justify-content-center">
              <div className="col-lg-8 col-12">
                {faqData.map((faq, index) => (
                  <div className="faq-item" key={index} data-aos="fade-up" data-aos-delay={index * 100}>
                    <div className="faq-question" onClick={() => toggleFaq(index)}>
                      <h5>{faq.question}</h5>
                      <div className={`faq-icon ${activeFaq === index ? 'active' : ''}`}><i className="bi bi-chevron-down"></i></div>
                    </div>
                    <div className={`faq-answer ${activeFaq === index ? 'show' : ''}`}>
                      <p>{faq.answer}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="cta-section">
          <div className="container">
            <h2>{ctaData.title}</h2>
            <p>{ctaData.subtitle}</p>
            <div className="cta-buttons">
              <a href={`tel:+91${whatsappNumber}`} className="btn-cta btn-cta-primary"><i className="bi bi-telephone me-2"></i>{ctaData.button1_text}</a>
              <a href={`https://wa.me/${whatsappNumber}`} className="btn-cta btn-cta-secondary" target="_blank" rel="noopener noreferrer"><i className="bi bi-whatsapp me-2"></i>{ctaData.button2_text}</a>
            </div>
          </div>
        </div>
      </div>

      {/* Floating Buttons */}
      <div className={`floating-buttons ${showFloatingButtons ? 'show' : ''}`}>
        <button className="floating-btn home" onClick={handleHomeClick}><i className="bi bi-house-door-fill"></i></button>
        <button className="floating-btn whatsapp" onClick={handleWhatsAppClick}><i className="bi bi-whatsapp"></i></button>
        <button className="floating-btn top" onClick={handleBackToTop}><i className="bi bi-arrow-up"></i></button>
      </div>
      <div className={`back-to-top ${showBackToTop ? 'show' : ''}`} onClick={handleBackToTop}><i className="bi bi-arrow-up"></i></div>
      
      <Footer />
    </>
  );
};

export default ContactUs;